import { React, useState, useEffect, useLayoutEffect, useRef } from "react";
import JobCardCylinderChild from "./JobCardCylinderChild";
import moment from "moment";
import {
  transformPatternData,
  patterns,
  transformPatternDuplexData,
} from "../../Utils/helper/helper";
import { Tooltip } from "antd";

import {
  currency_List,lengthUnit,weightUnit
  } from "../../Utils/Constant/MeasurementUnitList.jsx";

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const DuplexJobCardCylinder = ({ cylinderData, multiview, jobCard }) => {
  const divRef = useRef();
  const [width, setwidth] = useState();
  const [trList, settrList] = useState();
  const data = transformPatternDuplexData(
    cylinderData,
    jobCard
  );

  const [widthChange, setWidthChange] = useState(window.innerWidth);
  const handleWindowSizeChange = () => {
    setWidthChange(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useLayoutEffect(() => {
    if (divRef.current) {
      const _width = divRef.current.offsetWidth;
      if (width !== _width) setwidth(_width - 145);
    }
  }, [widthChange, divRef]);

  useEffect(() => {
    if (width && data && data.length) {
      const _trList = data.map((row) => {
        const heightLeft =
          (row.row_meta.left_length /
            (row.row_meta.left_width + row.row_meta.right_width + row.row_meta.right_trim_loss_width+row.row_meta.left_trim_loss_width)) *
          width;
        const heightRight =
          (row.row_meta.right_length /
            (row.row_meta.left_width + row.row_meta.right_width + row.row_meta.right_trim_loss_width+row.row_meta.left_trim_loss_width)) *
          width;
        //console.log(width, height);
        return (
            <div style={{ display: "flex"}}>
              <div style={ { display: "flex",width,flexDirection: "row",marginBottom: "5px",height: heightLeft > heightRight ? `${heightLeft}px` : `${heightRight}px`,minHeight : '70px'}}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width : `${
                    (row.row_meta.left_percentage)
                  }%`,
                }}
              >
                <div style={{ display: "flex", flexDirection: "row", width : '100%' }}>
                  {row.trLeft.length > 0 && row.row_meta.percentLeftTrimLossWidth > 0 &&
                    <Tooltip key={row?.trLeft?.length} title={`Type: Left Trim Loss\nTrim Loss: ${row?.row_meta?.left_trim_loss_width} ${row?.row_meta?.units?.left_trim_loss_width}`}>
                    <div
                        style={{
                          width: `${
                            (row.row_meta.percentLeftTrimLossWidth)
                          }%`,
                          height: `${heightLeft}px`,
                          minHeight: "70px",
                          backgroundColor: "white",
                          border: "none",
                          alignItems: "end",
                        }}
                        className="sheet-col"
                      >
                        <span>.</span>
                      </div>
                      </Tooltip>
                  }         
                  {row.trLeft.map((td, index) => (
                    <Tooltip
                      title={
                        td.type.toLowerCase() == "stock"
                          ? `Stock No.: ${td.order_id} \n Size: ${
                              row.row_meta.left_length 
                            } ${(lengthUnit[row.row_meta.units.left_length].displayName).toUpperCase()} X ${td.breadth} ${(lengthUnit[row.row_meta.units.left_width].displayName).toUpperCase()}
                      Grain: ${
                        td.grain.toLowerCase() === "short" ? "Short" : "Long"
                      } 
                                Weight: ${td.weight.toFixed(3)} ${capitalize(weightUnit[row.row_meta.units.left_order_weight].displayName)}
                                Priority:  ${td.priority === 1 ? "Yes" : "No"}`
                          : `Order No.: ${td.order_id} \n Size: ${
                              row.row_meta.left_length
                            } ${(lengthUnit[row.row_meta.units.left_length].displayName).toUpperCase()} X ${td.breadth} ${(lengthUnit[row.row_meta.units.left_width].displayName).toUpperCase()}
          Grain: ${td.grain.toLowerCase() === "short" ? "Short" : "Long"} 
                    Weight: ${td.weight.toFixed(3)} ${capitalize(weightUnit[row.row_meta.units.left_order_weight].displayName)}
                    Priority: ${td.priority === 1 ? "Yes" : "No"}
                    `
                      }
                    >
                      <div
                        className="sheet-col"
                        style={{
                          borderRight:
                            index === row.trLeft.length - 1
                              ? row.trRight.length ?  " 3px solid #A1A1A1"
                              : "" :'',
                          width: `${(( td.percentWidth))}%`,
                          height: `${heightLeft}px`,
                          minHeight: "70px",
                          backgroundColor:
                            td.type.toLowerCase() === "order" && !td.priority
                              ? "#FBE0DE"
                              : td.type.toLowerCase() === "order" && td.priority
                              ? "#FB967F"
                              : "#FFEFED",
                          alignItems: "end",
                        }}
                      >
                        {(td.percentWidth / 100) * width > 30 ? (
                          <span>{td.breadth}{lengthUnit[row.row_meta.units.left_length].displayName}</span>
                        ) : (
                          <span>.</span>
                        )}
                      </div>
                    </Tooltip>
                  ))}
                </div>
                {heightLeft < heightRight && (
                  <div
                    style={{
                      width: `100%`,
                      height: `${heightRight - heightLeft}px`,
                      backgroundColor: "white",
                      //borderRight :  ' 1px solid #909090',
                      borderRight:
                            
                               row.trRight.length ?  " 3px solid #A1A1A1"
                              : " 1px solid #A1A1A1" ,
                      
                      backgroundImage:
                        "repeating-linear-gradient(45deg, white 9px,#909090 10px, transparent 11px,transparent 12px)",
                    }}
                  ></div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width : `${
                    (row.row_meta.right_percentage)
                  }%`,
                }}
              >
                <div style={{ display: "flex", flexDirection: "row", width : '100%'}}>
                  {row.trRight.map((td, index) => (
                    <Tooltip
                      title={
                        td.type.toLowerCase() == "stock"
                          ? `Stock No.: ${td.order_id} \n Size: ${
                              row.row_meta.right_length
                            } ${(lengthUnit[row.row_meta.units.right_length].displayName).toUpperCase()} X ${td.breadth} ${(lengthUnit[row.row_meta.units.right_width].displayName).toUpperCase()}
                      Grain: ${
                        td.grain.toLowerCase() === "short" ? "Short" : "Long"
                      } 
                                Weight: ${td.weight.toFixed(3)} ${capitalize(weightUnit[row.row_meta.units.right_order_weight].displayName)}
                                Priority:  ${td.priority === 1 ? "Yes" : "No"}`
                          : `Order No.: ${td.order_id} \n Size: ${
                              row.row_meta.right_length
                            } ${(lengthUnit[row.row_meta.units.right_length].displayName).toUpperCase()} X ${td.breadth} ${(lengthUnit[row.row_meta.units.right_width].displayName).toUpperCase()}
          Grain: ${td.grain.toLowerCase() === "short" ? "Short" : "Long"} 
                    Weight: ${td.weight.toFixed(3)} ${capitalize(weightUnit[row.row_meta.units.right_order_weight].displayName)}
                    Priority: ${td.priority === 1 ? "Yes" : "No"}
                    `
                      }
                    >
                      <div
                        style={{
                          width: `${(td.percentWidth)}%`,
                          height: `${heightRight}px`,
                          backgroundColor:
                            td.type.toLowerCase() === "order" && !td.priority
                              ? "#E5B8B4"
                              : td.type.toLowerCase() === "order" && td.priority
                              ? "#EC988F"
                              : "#F2E6E2",
                          borderRight: " 1px solid #A1A1A1",
                          justifyContent: "center",
                          alignItems: "end",
                          minHeight: "70px",
                        }}
                        className="sheet-col"
                      >
                        {(td.percentWidth / 100) * width > 30 ? (
                          <span>{td.breadth} {lengthUnit[row.row_meta.units.right_width].displayName}</span>
                        ) : (
                          <span>.</span>
                        )}
                        {/* <br></br> */}
                      </div>
                    </Tooltip>
                  ))}
                  {console.log(row)}
                  {row.row_meta.percentRightTrimLossWidth > 0 &&
                    <Tooltip key={row?.trRight?.length} title={`Type: Right Trim Loss\nTrim Loss: ${row?.row_meta?.right_trim_loss_width} ${row?.row_meta?.units?.right_trim_loss_width}`}>
                      <div
                        style={{
                          width: `${
                            (row.row_meta.percentRightTrimLossWidth ) 
                          }%`,
                          height:  `${heightRight ? heightRight : heightLeft}px`,
                          minHeight: "70px",
                          backgroundColor: "white",
                          border: "none",
                          alignItems: "end",
                        }}
                        className="sheet-col"
                      >
                        <span>.</span>
                      </div>
                    </Tooltip>
                }
                </div>
                {(heightRight < heightLeft && row.trRight.length>0) && (
                  <div
                    style={{
                      width: `100%`,
                      height: `${heightLeft - heightRight}px`,
                      backgroundColor: "white",
                      //borderRight :  ' 1px solid #909090',
                      backgroundImage:
                        "repeating-linear-gradient(45deg, white 9px,#909090 10px, transparent 11px,transparent 12px)",
                    }}
                  ></div>
                )}
              </div>
              </div>
              <div
              style={{
                width: "145px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "5px",
              }}
            >
              <span
                style={{ fontSize: "12px", lineHeight: "16px", width: "145px",color : '#605E5C' }}
              >
                Trim Loss: {row.row_meta.total_trim_loss_width.toFixed(3)} {(lengthUnit[row.row_meta.units.total_trim_loss_width].displayName).toUpperCase()}
                <p style={{ fontSize: "10px", lineHeight: "16px",color : '#605E5C' }}>
                  Chop: <span style={{color:"#FF5E3B"}}>{row.row_meta.left_length }</span> , <span style={{color:"#CC8287"}}>{row.row_meta.right_length}</span> {(lengthUnit[row.row_meta.units.right_length].displayName).toUpperCase()}
                </p>
                <p style={{ fontSize: "10px", lineHeight: "16px",color : '#605E5C' }}>
                  Del: {moment(row.row_meta.deadline).format("DD MMM YYYY")}
                </p>
                <p style={{ fontSize: "10px", lineHeight: "16px",color : '#605E5C' }}>
                  Weight: <span style={{color:"#FF5E3B"}}>{row.row_meta.totalLeftWeight.toFixed(3)}</span>, <span style={{color:"#CC8287"}}>{row.row_meta.totalRightWeight.toFixed(3)}</span> {capitalize(weightUnit[row.row_meta.units.right_order_weight].displayName)}
                </p>
              </span>
            </div>
            </div>
         
        );
      });
      settrList(_trList);
    }
  }, [width]);

  return (
  <div ref={divRef} onResize={handleWindowSizeChange}>
    <div style={{ width }} >
    <div style={{ display: "flex", width,paddingBottom:"5px" }}>
    <div
      style={{
        justifyContent: "start",
        display: "flex",
        alignItems: "start",
        width: "100%",
        fontSize : "12px",
        color : '#FF5E3B',
        fontFamily : 'SF Pro Display Regular',
        fontWeight : "500",
        lineHeight : '16px',
      }}
    >
      {" "}
      Station 1
    </div>
    <div style={{
        justifyContent: "end",
        display: "flex",
        alignItems: "end",
        width: "100%",
        fontSize : "12px",
        color : '#CC8287',
        fontFamily : 'SF Pro Display Regular',
        fontWeight : "500",
        lineHeight : '16px',
      }}>Station 2</div>
  </div>
  </div>
    <div >
      {trList}
    </div>
  
  </div>
  );
};

export default DuplexJobCardCylinder;
